import axios from "axios";
import { readStoredLocation } from "../utils/storage";

// Per-environment values come from .env.development (local) and the production
// env. Create React App inlines REACT_APP_* at build time, so changing one
// requires restarting `npm start` or re-running `npm run build`.
const backendUrl = process.env.REACT_APP_BACKEND_URL;

if (!backendUrl) {
    console.error(
        "REACT_APP_BACKEND_URL is not set. Add it to .env.development (local) or your production environment and rebuild."
    );
}

// The env var holds the server origin only; every API route lives under /api.
const baseUrl = `${(backendUrl || "").replace(/\/+$/, "")}/api`;

//creating an axios instance with auth setup
const axiosInstance = axios.create({
    baseURL: baseUrl,
    timeout: 400000,
});

axiosInstance.interceptors.request.use((config) => {
    if (config.withCredentials) {
        config.headers["Authorization"] = "Token " + localStorage.getItem("device_id");
    }

    const location = readStoredLocation();

    if (location) {
        // Add query parameter
        const params = new URLSearchParams();
        params.append("zip", location.zip);
        config.url += (config.url.includes("?") ? "&" : "?") + params.toString();
    }

    return config;
});

//defining the interceptor which will automate the process of refresh and access token
axiosInstance.interceptors.response.use(
    function (response) {
        // Simply returning the response
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default axiosInstance;
